import { render } from "./fileManage.vue?vue&type=template&id=ab7b722c&scoped=true"
import script from "./fileManage.vue?vue&type=script&lang=js"
export * from "./fileManage.vue?vue&type=script&lang=js"

import "./fileManage.vue?vue&type=style&index=0&id=ab7b722c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab7b722c"]])

export default __exports__